import React, { useState, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { Checkbox, InputNumber } from 'antd'

import { FlexRow } from '../../../FlexboxReusables/FlexItems'
import { CourseContext } from '../../../Course/CourseContext'
import { Course } from '../../../Course/types'
import { IndentedOption, SubOptionsRow } from './utils'

type PurchaseOptionsProps = {
  canBePurchased?: boolean
  purchasePrice: number
  course: Course
}

const PurchaseOptions = ({ canBePurchased, purchasePrice, course }: PurchaseOptionsProps) => {
  const { updateCourse } = useContext(CourseContext)
  const [ courseCanBePurchased, setCourseCanBePurchased ] = useState(canBePurchased || false)
  const [ price, setPrice ] = useState(purchasePrice || 0)

  useEffect(() => {
    if (courseCanBePurchased && price) {
      updateCourse({
        ...course,
        canBePurchased: courseCanBePurchased,
        purchasePrice: price,
      })
    }
  }, [ courseCanBePurchased, price ])

  return (
    <IndentedOption>
      <SubOptionsRow>
        <Checkbox
          checked={courseCanBePurchased}
          onChange={() => setCourseCanBePurchased(!courseCanBePurchased)}
        >
          <FormattedMessage id='purchaseOptions.canBePurchased' />
        </Checkbox>
      </SubOptionsRow>
      {courseCanBePurchased && (
        <>
          <SubOptionsRow>
            <FormattedMessage id='purchaseOptions.purchasePrice' />
          </SubOptionsRow>
          <SubOptionsRow>
            <InputNumber
              defaultValue={purchasePrice || 0}
              onChange={(value: number | null) => setPrice(value || 0)}
            />
            <CurrencySymbol>€</CurrencySymbol>
          </SubOptionsRow>
        </>
      )}
    </IndentedOption>
  )
}

export default PurchaseOptions

const CurrencySymbol = styled.div`
  margin-left: 0.5em;
`
